// extracted by mini-css-extract-plugin
module.exports = {"admin_sidebar_footer":"Footer_admin_sidebar_footer__2bQjU"};